export default __webpack_public_path__ + "2b3a2d493082605fcd10d535b7888786.pdf";